var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8864 13.8517C5.7879 13.9506 5.6598 14 5.5023 14C5.3644 14 5.2462 13.9506 5.1477 13.8517C5.0492 13.7331 5 13.6045 5 13.4661C5 13.3277 5.0492 13.209 5.1477 13.1102L11.1159 7.14831C11.2341 7.04944 11.3621 7 11.5 7C11.6379 7 11.7659 7.04944 11.8841 7.14831L17.8523 13.1102C17.9508 13.209 18 13.3277 18 13.4661C18 13.6045 17.9508 13.7331 17.8523 13.8517C17.7538 13.9506 17.6258 14 17.4682 14C17.3303 14 17.2121 13.9506 17.1136 13.8517L11.5 8.42373L5.8864 13.8517Z",
    fill: "#29363D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.1da34816d3a34973c37ba7a27c34067a.svg";
export { ForwardRef as ReactComponent };